import { ArrowLeft, Construction } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { buttonStyles } from "@/components/ui/Button";
import { PageBody } from "@/components/ui/PageHeader";

/** Unfinished modules render this screen without mounting their data or edit hooks. */
export function ComingSoonPage({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();

  return (
    <PageBody width="narrow">
      <section className="my-8 rounded-lg border border-line bg-surface px-6 py-12 text-center sm:my-16 sm:px-10 sm:py-16">
        <div className="mx-auto flex size-20 items-center justify-center rounded-full border border-line bg-paper">
          <Construction className="size-9 text-ink-soft" aria-hidden="true" />
        </div>
        <p className="mt-6 text-sm font-medium text-ink-soft">{t(titleKey)}</p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-ink">
          {t("comingSoon.title")}
        </h1>
        <p className="mx-auto mt-3 max-w-sm text-base leading-relaxed text-ink-soft">
          {t("comingSoon.description")}
        </p>
        <Link to="/" className={`${buttonStyles({ variant: "primary" })} mt-8`}>
          <ArrowLeft className="size-4" aria-hidden="true" />
          {t("comingSoon.backToOverview")}
        </Link>
      </section>
    </PageBody>
  );
}
